import { Plus } from 'lucide-react';
import { useIntl } from 'react-intl';

import { Card, CardContent } from '@/shared/ui/card';

import { AddNewStoryDialog } from './add-new-story-dialog';

export const AddNewStoryButton = () => {
  const intl = useIntl();

  return (
    <AddNewStoryDialog>
      <Card className="flex h-full min-w-full cursor-pointer justify-center py-8 sm:max-h-[255px] md:min-w-[380px]">
        <CardContent className="flex h-full max-w-[340px] flex-col items-center justify-center px-8 pb-0 text-center">
          <Plus className="mb-4" size={40} />

          <p className="mb-2 text-2xl font-semibold">
            {intl.formatMessage({ id: 'button.addNewStory' })}
          </p>

          <p>{intl.formatMessage({ id: 'button.addNewStory.description' })}</p>
        </CardContent>
      </Card>
    </AddNewStoryDialog>
  );
};
